import { Locale } from '@revolugo/common/constants'

export enum Endpoint {
  AccountConfirmation = 'users/confirmation',
  AccountCreate = 'users',
  AccountPassword = 'users/password',
  SessionCreate = 'users/sign_in',
  SessionDelete = 'users/sign_out',
}

export const DEFAULT_LOCALE = Locale.en_US

export const DEBUG_MODE = import.meta.env.MODE !== 'production'

export type InputName =
  | 'firstName'
  | 'lastName'
  | 'email'
  | 'organization'
  | 'password'
  | 'passwordConfirmation'

export enum ComponentSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  Xl = 'xl',
  XXl = '2xl',
}
